export const NUMBER_OF_INITIAL_MESSAGES = 50;
export const NUMBER_OF_EARLIER_MESSAGES = 20;
export const ROOT_URL = {
    d: "ws://localhost:3000/",
    s: "wss://vision-stg.pi314.in/",
    p: "wss://krishidevgyan.com/"
};
